import { render, staticRenderFns } from "./columnItem.vue?vue&type=template&id=72723468&"
import script from "./columnItem.vue?vue&type=script&lang=js&"
export * from "./columnItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports